export const logError = (error: Error) => {
  //const isTestEnvironment = useIsTestEnvVariable();

  console.error(`Error: ${error.message}`);
};
